// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"164":"479c7ff542d02769","181":"5df5ae0d22e41f97"}[chunkId] + ".js";
};